"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SkeletonCatalogueMobile = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const SkeletonCatalogueMobile = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.SkeletonCatalogueMobileRoot, {
    "data-testid": getTestId(_constants.SKELETON_CATALOGUE_MOBILE),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Skeleton, {
      variant: "rounded",
      height: 103,
      width: "100%"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Skeleton, {
      variant: "rounded",
      height: 30,
      width: 50
    })]
  });
};
exports.SkeletonCatalogueMobile = SkeletonCatalogueMobile;
